import { useEffect, useState } from 'react'
import { AudioOutlined } from '@ant-design/icons'
import { Button, Input } from 'antd'
import { useSnapshot } from 'valtio'

import styles from './index.module.less'

import { Footer } from '../content'
import { message } from '@/App'
import { assistantState, configState, assistantAction } from '@/store'
import useRecorder from '@/hooks/useRecorder'
import useChineseInput from '@/hooks/useChineseInput'
import union from '@/assets/images/union.svg'
import PluginBar from '../Plugins/PluginBar'
import send from '@/assets/images/icon/send.svg'
import { useAgentChat } from '@/hooks/useAgentChat'
import { useResponsive } from 'ahooks'
import SendBtn from '../SendButton'
import ActionIcon from '@/components/ChatInputArea/actions/ActionIcon'
import styled from 'styled-components'
import { nanoid } from 'nanoid'
import CleanMessage from '@/assets/images/chat/clean_message.svg?react'
import NewChatIcon from '@/assets/images/chat/new_chat_icon.svg?react'
import { SessionStatuTypes } from '@/constants'
import { cn } from '@/utils/css'

const Warper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  background-color: #1c1f231a;
  border-radius: 50%;
  padding: 4px;
  .wave {
    width: 20px;
    height: 20px;
    --c: no-repeat
      linear-gradient(to right, #9747ff 0%, #7b61ff 50%, #2e90fa 100%);
    background: var(--c) 0% 50%, var(--c) 25% 50%, var(--c) 50% 50%,
      var(--c) 75% 50%, var(--c) 100% 50%;
    background-size: 10% 20%, 10% 40%, 10% 60%, 10% 40%, 10% 20%;
    animation: audioWave 1.5s infinite ease-in-out;
  }
  @keyframes audioWave {
    0% {
      background-size: 10% 20%, 10% 40%, 10% 60%, 10% 40%, 10% 20%;
    }
    /* 20%,
    80% {
      background-size: 10% 30%, 10% 50%, 10% 50%, 10% 50%, 10% 30%;
    }
    30%,
    70% {
      background-size: 10% 40%, 10% 60%, 10% 40%, 10% 60%, 10% 40%;
    }
    40%,
    60% {
      background-size: 10% 50%, 10% 50%, 10% 30%, 10% 50%, 10% 50%;
    } */
    50% {
      background-size: 10% 60%, 10% 40%, 10% 20%, 10% 40%, 10% 60%;
    }
  }
`
const AudioWave = () => {
  return (
    <Warper>
      <div className="wave" />
    </Warper>
  )
}

const MicSvgIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.66675C9.33696 1.66675 8.70107 1.93014 8.23223 2.39898C7.76339 2.86782 7.5 3.50371 7.5 4.16675V10.0001C7.5 10.6631 7.76339 11.299 8.23223 11.7678C8.70107 12.2367 9.33696 12.5001 10 12.5001C10.663 12.5001 11.2989 12.2367 11.7678 11.7678C12.2366 11.299 12.5 10.6631 12.5 10.0001V4.16675C12.5 3.50371 12.2366 2.86782 11.7678 2.39898C11.2989 1.93014 10.663 1.66675 10 1.66675Z"
      stroke="#1C1F23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8332 8.33325V9.99992C15.8332 11.547 15.2186 13.0307 14.1246 14.1247C13.0307 15.2187 11.5469 15.8333 9.99984 15.8333C8.45274 15.8333 6.96901 15.2187 5.87505 14.1247C4.78109 13.0307 4.1665 11.547 4.1665 9.99992V8.33325"
      stroke="#1C1F23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0002 15.8333L10 18.9987"
      stroke="#1C1F23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18.9988H8"
      stroke="#1C1F23"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
const ChatTrigger = ({
  validateForm,
  isShowClean = true,
  onUserSubmit,
  isLoading,
  stopSession,
}: any) => {
  const [recordText, setRecordText] = useState('')
  const { inputText, sessionStatu, isLoadingQuestion } =
    useSnapshot(assistantState)
  const { baseConfig } = useSnapshot(configState)
  const resposive = useResponsive()
  const { recStatus, recOpen, recStop } = useRecorder(
    import.meta.env.VITE_APP_ASR_WS_URL,
    {
      onOpen: () => {
        assistantState.inputText = ''
        setRecordText('')
      },
      onMessage: (data: any) => {
        parseAsrResult(data)
      },
      onClose: (event: any) => {
        if (assistantState.inputText?.endsWith(',')) {
          const text = assistantState.inputText.slice(0, -1)
          assistantState.inputText = text
        }
      },
    },
  )

  const parseAsrResult = (data: any) => {
    let sentence = ''
    if (data.type === 'partial_result') {
      let nbest = JSON.parse(data.nbest)
      sentence = nbest[0]?.sentence
      if (nbest.length > 0) {
        assistantState.inputText = recordText ? recordText + sentence : sentence
      }
    }
    if (data.type === 'final_result') {
      let nbest = JSON.parse(data.nbest)
      sentence = nbest[0]?.sentence
      if (nbest.length > 0) {
        assistantState.inputText = recordText ? recordText + sentence : sentence
        setRecordText(recordText ? recordText + sentence : sentence)
      }
    }
  }

  const {
    curValue,
    handleChange,
    handleCompositionStart,
    handleCompositionEnd,
  } = useChineseInput(inputText, (value: string) => {
    assistantState.inputText = value
  })
  const handleNewChat = async () => {
    // eslint-disable-next-line valtio/state-snapshot-rule
    if (sessionStatu !== SessionStatuTypes.ready) {
      return
    }
    assistantAction.updateQuestionGuides([])
    const messages = assistantState.sessionMessages
    const lastMessage: any = messages[messages.length - 1] || {}
    assistantState.curChatId = nanoid()
    if (!lastMessage.newChat) {
      messages.push({ newChat: true })
    }
  }

  const refreshAgent = () => {
    // eslint-disable-next-line valtio/state-snapshot-rule
    if (sessionStatu !== SessionStatuTypes.ready) {
      return
    }
    assistantAction.updateSessionMessages([])
    assistantAction.updateQuestionGuides([])
  }

  const onEnter = () => {
    const text = assistantState.inputText.trim()
    if (!assistantState.submittable) {
      message.error('请先完成智能体配置的必填项')
      validateForm()
      return
    }
    if (!assistantState.curSelectAssistant?.app_id) {
      message.error('请先完成调试智能体创建')
      return
    }
    if (!text) {
      message.warning('请输入问题')
      return
    }

    // assistantAction.onUserSubmit(text)
    onUserSubmit(text)
    assistantState.inputText = ''
  }
  useEffect(() => {
    return () => {
      assistantState.inputText = ''
    }
  }, [])
  useEffect(() => {
    if (recStatus === 'start' && sessionStatu !== SessionStatuTypes.ready) {
      recStop()
    }
  }, [recStatus, recStop, sessionStatu])
  return (
    <div className={styles.chatTriggerWrap}>
      <div className="h-6 absolute inset-0 -top-5 bg-gradient-to-b from-white/50 to-white blur-sm -z-[1] hidden md:block"></div>
      {/* {isShowQuit && <PluginBar />} */}
      <div className={styles.content}>
        <div className={styles.inputWrap}>
          <Input.TextArea
            rows={1}
            className={styles.input}
            value={curValue}
            onChange={handleChange}
            onCompositionStart={handleCompositionStart}
            onCompositionEnd={handleCompositionEnd}
            placeholder="请输入问题，可通过 Shift + 回车换行"
            maxLength={baseConfig.limitLength}
            autoSize={{ maxRows: 3, minRows: resposive.sm ? 1 : 1 }}
            variant={'borderless'}
            onPressEnter={e => {
              if (e.key === 'Enter' && e.shiftKey) return
              // eslint-disable-next-line
              // @ts-expect-error
              if (e.keyCode !== 13 || e.isComposing) return
              e.preventDefault()
              onEnter()
            }}
          />
        </div>
        <div className={styles.actionWrap}>
          <div className="flex flex-row gap-1">
            {isShowClean && (
              <div
                className={cn(
                  'flex justify-center items-center gap-1 h-7 px-2 border border-[#1C1F231A] rounded-full text-center text-[12px] text-[#1C1F23] hover:border-[#1C1F231A]',
                  sessionStatu !== SessionStatuTypes.ready && 'opacity-50',
                )}
                onClick={refreshAgent}
              >
                <CleanMessage className="h-4 w-4" />
                <span className="whitespace-nowrap">清空上下文</span>
              </div>
            )}
            {
              <div
                className={cn(
                  'flex justify-center items-center gap-1 h-7 px-2 border border-[#1C1F231A] rounded-full text-center text-[12px] text-[#1C1F23]',
                  sessionStatu !== SessionStatuTypes.ready && 'opacity-50',
                )}
                onClick={handleNewChat}
              >
                <NewChatIcon className="h-4 w-4" />
                <span className="whitespace-nowrap">新的问答</span>
              </div>
            }
          </div>
          <div className="flex flex-row items-center gap-2">
            <ActionIcon
              className="hover:bg-transparent"
              title={recStatus === 'start' ? '停止语音输入' : '语音输入'}
              Icon={recStatus === 'start' ? AudioWave : MicSvgIcon}
              onClick={() => {
                // recStatus === 'start' ? recStop() : recOpen()
                if (recStatus === 'start') {
                  recStop()
                  return
                }
                // 检查会话状态，只有在 ready 状态时才允许开始录音
                if (sessionStatu !== SessionStatuTypes.ready) {
                  message.warning('请等待对话完成后再使用语音输入')
                  return
                }
                recOpen()
              }}
            />
            {/* <div className={styles.record}>
              <div className={`flex w-full ${styles.recordBox}`}>
                <div
                  className={`audio-wave ${styles.recordStatus}`}
                  style={{
                    visibility: recStatus === 'start' ? 'visible' : 'hidden',
                  }}
                />
                <Button
                  className={styles.recordBtn}
                  icon={
                    recStatus === 'start' ? (
                      <img src={union} />
                    ) : (
                      <AudioOutlined />
                    )
                  }
                  type="default"
                  onClick={() => {
                    recStatus === 'start' ? recStop() : recOpen()
                  }}
                />
              </div>
            </div> */}
            {/* <div className={styles.send} onClick={onEnter}>
              <img src={send} />
            </div> */}
            <SendBtn
              curValue={curValue && curValue.length > 0 ? curValue : ''}
              loading={isLoadingQuestion || isLoading}
              onSend={onEnter}
              onStop={stopSession}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default ChatTrigger
